import { format, startOfMonth } from 'date-fns'
import { FilterForm } from './filters/filters.types'

const subtractDays = (date: Date, days: number) => {
  const temp = new Date(date)
  temp.setDate(date.getDate() - days)

  return temp
}
const subtractMonths = (date: Date, months: number) => {
  const temp = new Date(date)
  temp.setMonth(date.getMonth() - months)

  return temp
}
const getFirstDayOfMonth = (date: Date) => {
  const temp = new Date(date)

  return startOfMonth(temp)
}

type GenerateMetricFiltersOutput = { [key: string]: string | string[] }
export const generateMetricFilters = (filters: FilterForm): GenerateMetricFiltersOutput => {
  const params: { [key: string]: string | string[] } = {}

  if (!filters) return params

  // TODO: remove these array parsing until multiselect is properly added to filter modal
  if (filters.professional.length > 0 && filters.professional.length !== filters.professionalLength)
    params.professional_id = filters.professional.map(item => item.id)

  if (filters.cohort.length > 0 && filters.cohort.length !== filters.cohortLength)
    params.cohort_id = filters.cohort.map(item => item.id)

  if (filters.careTeam.length > 0 && filters.careTeam.length !== filters.careTeamLength)
    params.care_team_id = filters.careTeam.map(item => item.id)

  if (filters.guideline.length > 0 && filters.guideline.length !== filters.guidelineLength)
    params.guideline_id = filters.guideline.map(item => item.id)

  if (filters.period?.id === 'custom') {
    if (filters.startDate) params.date_gte = format(filters.startDate, 'yyyy-MM-dd')
    if (filters.endDate) params.date_lte = format(filters.endDate, 'yyyy-MM-dd')
  } else {
    if (filters.period?.id === 'today') {
      params.date = format(new Date(), 'yyyy-MM-dd')
    }
    if (filters.period?.id === 'last7') {
      params.date_gte = format(subtractDays(new Date(), 7), 'yyyy-MM-dd')
      params.date_lte = format(new Date(), 'yyyy-MM-dd')
    }
    if (filters.period?.id === 'last30') {
      params.date_gte = format(subtractMonths(new Date(), 1), 'yyyy-MM-dd')
      params.date_lte = format(new Date(), 'yyyy-MM-dd')
    }
    if (filters.period?.id === 'lastMonth') {
      params.date_gte = format(subtractMonths(getFirstDayOfMonth(new Date()), 1), 'yyyy-MM-dd')
      params.date_lte = format(subtractDays(getFirstDayOfMonth(new Date()), 1), 'yyyy-MM-dd')
    }
    if (filters.period?.id === 'last12months') {
      params.date_gte = format(subtractMonths(new Date(), 12), 'yyyy-MM-dd')
      params.date_lte = format(new Date(), 'yyyy-MM-dd')
    }
  }
  return params
}
